import React, { useState, useEffect } from "react";
import axios from "axios";
import SkeletonArticle from "../../components/Post_skaliton/SkeletonArticle";
import QnaContent from "../../components/Right/QnaContent";
import InfiniteScroll from "react-infinite-scroll-component";
import DogWithBoll from "../../../src/Assets/Images/dogwithball.gif";
const Qna = () => {
  const [posts, setPosts] = useState([]);
  const [loadingEvent, setLoadingEvent] = useState(true);
  const [paginate, setPaginate] = useState(1);
  const [noData, setNoData] = useState(false);

  const fetchData = () => {
    axios
      .get(`api/user/post/qna/with-paginate/4?page=${paginate}`)
      .then((res) => {
        if (res.data.status === 200) {
          setPosts([...posts, ...res.data.post]);
          setPaginate(paginate + 1);
          setLoadingEvent(false);
          if (res.data.post.length === 0) {
            setNoData(true);
          }
        }
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <center>
      <InfiniteScroll
        dataLength={posts.length}
        next={fetchData}
        hasMore={true}
        loader={ noData && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={DogWithBoll} style={{ height: 250, width: 500 }} />
            <h4 className="text-center text-warning">
              No Data found!
            </h4>
          </div>
        )}
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>You have seen it all</b>
          </p>
        }
      >
        {loadingEvent &&
          [1, 2, 3, 4].map(() => <SkeletonArticle theme="dark" />)}

        {posts.map((event) => (
          <QnaContent key={event.id} post={event} />
        ))}
      </InfiniteScroll>
    </center>
  );
};

export default Qna;
